/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BridgeApiConversationRequestedFields } from './BridgeApiConversationRequestedFields';
import {
    BridgeApiConversationRequestedFieldsFromJSON,
    BridgeApiConversationRequestedFieldsFromJSONTyped,
    BridgeApiConversationRequestedFieldsToJSON,
    BridgeApiConversationRequestedFieldsToJSONTyped,
} from './BridgeApiConversationRequestedFields';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * a Conversation
 * @export
 * @interface BridgeApiCreateConversationV2
 */
export interface BridgeApiCreateConversationV2 {
    /**
     * 
     * @type {number}
     * @memberof BridgeApiCreateConversationV2
     */
    alertId: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof BridgeApiCreateConversationV2
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationV2
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationV2
     */
    categoryId: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationV2
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationV2
     */
    attributes?: string;
    /**
     * 
     * @type {BridgeApiConversationRequestedFields}
     * @memberof BridgeApiCreateConversationV2
     */
    requestedFields?: BridgeApiConversationRequestedFields;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationV2
     */
    recipientOrganisationId: string;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiCreateConversationV2
     */
    urgent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BridgeApiCreateConversationV2
     */
    isReScreeningEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BridgeApiCreateConversationV2
     */
    messageContent: string;
    /**
     * Message attachment ids
     * @type {Array<string>}
     * @memberof BridgeApiCreateConversationV2
     */
    messageAttachmentIds?: Array<string>;
}



/**
 * Check if a given object implements the BridgeApiCreateConversationV2 interface.
 */
export function instanceOfBridgeApiCreateConversationV2(value: object): value is BridgeApiCreateConversationV2 {
    if (!('alertId' in value) || value['alertId'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    if (!('recipientOrganisationId' in value) || value['recipientOrganisationId'] === undefined) return false;
    if (!('urgent' in value) || value['urgent'] === undefined) return false;
    if (!('messageContent' in value) || value['messageContent'] === undefined) return false;
    return true;
}

export function BridgeApiCreateConversationV2FromJSON(json: any): BridgeApiCreateConversationV2 {
    return BridgeApiCreateConversationV2FromJSONTyped(json, false);
}

export function BridgeApiCreateConversationV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): BridgeApiCreateConversationV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'alertId': json['alertId'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'title': json['title'],
        'categoryId': json['categoryId'],
        'templateId': json['templateId'],
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
        'requestedFields': json['requestedFields'] == null ? undefined : BridgeApiConversationRequestedFieldsFromJSON(json['requestedFields']),
        'recipientOrganisationId': json['recipientOrganisationId'],
        'urgent': json['urgent'],
        'isReScreeningEnabled': json['isReScreeningEnabled'] == null ? undefined : json['isReScreeningEnabled'],
        'messageContent': json['messageContent'],
        'messageAttachmentIds': json['messageAttachmentIds'] == null ? undefined : json['messageAttachmentIds'],
    };
}

export function BridgeApiCreateConversationV2ToJSON(json: any): BridgeApiCreateConversationV2 {
    return BridgeApiCreateConversationV2ToJSONTyped(json, false);
}

export function BridgeApiCreateConversationV2ToJSONTyped(value?: BridgeApiCreateConversationV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertId': value['alertId'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'title': value['title'],
        'categoryId': value['categoryId'],
        'templateId': value['templateId'],
        'attributes': value['attributes'],
        'requestedFields': BridgeApiConversationRequestedFieldsToJSON(value['requestedFields']),
        'recipientOrganisationId': value['recipientOrganisationId'],
        'urgent': value['urgent'],
        'isReScreeningEnabled': value['isReScreeningEnabled'],
        'messageContent': value['messageContent'],
        'messageAttachmentIds': value['messageAttachmentIds'],
    };
}

